import { TipoCanalComunicacao } from "constants/EnumTipoCanalComunicacao";
import { TipoMotivoInadimplencia } from "constants/EnumTipoMotivoInadimplencia";
import { TipoResultadoContato } from "constants/EnumTipoResultadoContato";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

const registrarContatoRealizadoSchema = yup.object().shape({
  contatoRealizadoCom: yup.string().required(mensagemDeErroPadrao("Contato realizado com")),
  dataContato: yup
    .date()
    .required(mensagemDeErroPadrao("Data do contato"))
    .typeError("Informe uma data válida"),
  horarioContato: yup
    .date()
    .required(mensagemDeErroPadrao("Horário"))
    .typeError("Informe um horário válido"),
  canalComunicacao: yup
    .mixed<TipoCanalComunicacao>()
    .transform((opcao: SelectOptionType<TipoCanalComunicacao>) => opcao?.value)
    .required(mensagemDeErroPadrao("Canal de comunicação")),
  resultadoContato: yup
    .mixed<TipoResultadoContato>()
    .transform((opcao: SelectOptionType<TipoCanalComunicacao>) => opcao?.value)
    .required(mensagemDeErroPadrao("Resultado do contato")),
  motivoInadimplencia: yup
    .mixed<TipoMotivoInadimplencia>()
    .transform((opcao: SelectOptionType<TipoCanalComunicacao>) => opcao?.value)
    .required(mensagemDeErroPadrao("Motivo da inadimplência")),
  anotacoes: yup.string().required(mensagemDeErroPadrao("Anotações")),
});

export default registrarContatoRealizadoSchema;
